import { render, staticRenderFns } from "./AgentYtdSalesProfitNumberDisplayer.vue?vue&type=template&id=850c5386"
import script from "./AgentYtdSalesProfitNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./AgentYtdSalesProfitNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports